import { createAsyncThunk } from '@reduxjs/toolkit';
import PropertiesVisitService from '@/services/PropertiesVisitService';
import SharePropertiesMultipleSourcesService from '@/services/SharePropertiesMultipleSourcesService';
import CalendarService from '@/services/CalendarService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`PropertiesVisit/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getCalendarConfig = handler(
  'getCalendarConfig',
  PropertiesVisitService.getCalendarConfig
);

export const getCalendarStatus = handler(
  'getCalendarStatus',
  PropertiesVisitService.getCalendarStatus
);

export const openCalendar = handler(
  'openCalendar',
  PropertiesVisitService.updateCalendarStatus
);

export const closeCalendar = handler(
  'closeCalendar',
  PropertiesVisitService.updateCalendarStatus
);

export const blockDateFullDays = handler(
  'blockDateFullDays',
  PropertiesVisitService.updateCalendarConfig
);

export const blockDateRangeDay = handler(
  'blockDateRangeDay',
  PropertiesVisitService.updateCalendarConfig
);

export const selectSchedule = handler(
  'selectSchedule',
  PropertiesVisitService.updateCalendarConfig
);

export const setVisitDuration = handler(
  'setVisitDuration',
  PropertiesVisitService.updateCalendarConfig
);

export const deleteSpecificException = handler(
  'deleteSpecificException',
  PropertiesVisitService.deleteCalendarConfig
);

export const deleteSelectedExceptions = handler(
  'deleteSelectedExceptions',
  PropertiesVisitService.deleteCalendarConfig
);

export const getEventTypesList = handler(
  'getEventTypesList',
  PropertiesVisitService.getEventTypesList
);

export const getVisitEvents = handler(
  'getVisitEvents',
  PropertiesVisitService.getVisitEvents
);

export const cancelVisit = handler(
  'cancelVisit',
  PropertiesVisitService.cancelVisit
);

export const getTimeline = handler(
  'getTimeline',
  PropertiesVisitService.getTimeline
);

export const toggleParticipant = handler(
  'toggleParticipant',
  PropertiesVisitService.updateCalendarConfig
);

export const addAgent = handler(
  'addAgent',
  PropertiesVisitService.updateCalendarConfig
);

export const removeAgent = handler(
  'removeAgent',
  PropertiesVisitService.deleteCalendarConfig
);

export const addContact = handler(
  'addContact',
  PropertiesVisitService.updateCalendarConfig
);

export const removeContact = handler(
  'removeContact',
  PropertiesVisitService.deleteCalendarConfig
);

export const refreshExceptions = handler(
  'refreshExceptions',
  PropertiesVisitService.getCalendarConfig
);

export const modifyAvailability = handler(
  'modifyAvailability',
  PropertiesVisitService.updateCalendarConfig
);

export const toggleVisitField = handler(
  'toggleVisitField',
  PropertiesVisitService.updateCalendarConfig
);

export const addCustomField = handler(
  'addCustomField',
  PropertiesVisitService.updateCalendarConfig
);

export const removeExtraField = handler(
  'removeExtraField',
  PropertiesVisitService.deleteCalendarConfig
);

export const getPropertyInfo = handler(
  'getPropertyInfo',
  PropertiesVisitService.getProperty
);

export const postCreateMessageContact = handler(
  'postCreateMessageContact',
  SharePropertiesMultipleSourcesService.postCreateMessageContact
);

export const deletePropertyConfiguration = handler(
  'deletePropertyConfiguration',
  PropertiesVisitService.deletePropertyConfiguration
);

export const deleteEvent = handler('deleteEvent', CalendarService.deleteEvent);

export const getVisitData = handler(
  'getVisitData',
  PropertiesVisitService.getVisitData
);

export const confirmVisit = handler(
  'confirmVisit',
  CalendarService.confirmVisit
);
